import {useRef} from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/pro-light-svg-icons';

export const SearchInput = ({
  placeholder = 'Search',
  onChange = () => {},
}) => {
  const ref = useRef(null);
  
  const handleClear = (e) => {
    e.preventDefault();
    if(ref.current.value !== '') {
      ref.current.value = '';
      onChange();
    }
  } 

  return (
    <InputGroup id="search-input-group">
      <InputGroup.Text id="mag">
        <FontAwesomeIcon icon={faMagnifyingGlass} size="lg" />
      </InputGroup.Text>
      <Form.Control ref={ref} data-testid="search-box" aria-describedby="mag" type="text" className="search-input" placeholder={placeholder} onChange={event => onChange(event?.target?.value)}/>
      <InputGroup.Text id="clear">
        <FontAwesomeIcon className="pointer" icon={faXmark} size="lg" onClick={handleClear} />
      </InputGroup.Text>
    </InputGroup>
    
  );
};

export default SearchInput;
